import React from 'react';
import { Redirect } from 'react-router-dom';

const DashboardWrapper = () => (<Redirect from="/" to="/dashboard" />);

export default DashboardWrapper;
